export const CHAT_LIST_SIZE = 5;
